import './Process.css';

const Process = () => {
  const steps = [
    {
      number: '01',
      icon: 'fas fa-comments',
      title: 'Contato Inicial',
      description: 'Você entra em contato pelo WhatsApp ou formulário. Entendemos suas necessidades, tipo de evento, data e local.'
    },
    {
      number: '02',
      icon: 'fas fa-drafting-compass',
      title: 'Projeto Personalizado',
      description: 'Nossa equipe elabora um projeto sob medida com a melhor configuração de painéis de LED para seu evento.'
    },
    {
      number: '03',
      icon: 'fas fa-tools',
      title: 'Montagem Profissional',
      description: 'Equipe técnica especializada realiza a instalação completa no local, com antecedência e testes rigorosos.'
    },
    {
      number: '04',
      icon: 'fas fa-star',
      title: 'Evento Impecável',
      description: 'Suporte técnico presente durante todo o evento para garantir que tudo funcione perfeitamente.'
    }
  ];

  return (
    <section className="process">
      <div className="section-container">
        <div className="section-header" data-aos="fade-up">
          <span className="section-label">Como Funciona</span>
          <h2>Do orçamento ao evento em <span>4 passos simples</span></h2>
          <p>Processo descomplicado para você focar no que importa: seu evento.</p>
        </div>

        <div className="process__timeline">
          {steps.map((step, index) => (
            <div key={index} className="process__step" data-aos="fade-up" data-aos-delay={index * 100}>
              <div className="process__step-number">{step.number}</div>
              <div className="process__step-icon">
                <i className={step.icon}></i>
              </div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
              {index < steps.length - 1 && <div className="process__connector"></div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
